import Flex from '@Components/Bases/Flex';
import SearchCheckboxList from '@Components/SearchCheckboxList';
import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { Box, InputLabel, Typography } from '@mui/material';
import Tags from '@Router/ImpactsOnStakeholdersManagement/Containers/StakeholderAnalysisValueChainOfBusiness/ModalAddStakeholderAnalysis/Tags';
import { useState } from 'react';
import FormCheckboxList from './FormCheckboxList';
import InputOtherSection from './InputOtherSection';

type CommunicationActivitiesCheckboxListProps = {
  name: string;
  value: IInfoCategoryMasterData[];
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const CommunicationActivitiesCheckboxList = ({
  value,
  name,
  isCompletedTh,
  isCompletedEn,
}: CommunicationActivitiesCheckboxListProps) => {
  const [filterText, setFilterText] = useState<string>('');
  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterText(event.target.value);
  };

  const filteredStakeholders = value.filter((stakeholder) =>
    stakeholder.nameTh.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Box width={1}>
      <Typography fontWeight={'bold'} mb={2}>
        ช่องทางการมีส่วนร่วมและสื่อสาร (ถ้ามี)
      </Typography>
      <Flex>
        <Box flex={1}>
          <InputLabel
            sx={{
              textAlign: 'right',
              marginRight: 2,
            }}
          >
            ช่องทางการมีส่วนร่วมและสื่อสาร
          </InputLabel>
        </Box>
        <Flex flexDirection={'column'} width={1} maxWidth={600}>
          <Tags disabled={isCompletedEn || isCompletedTh} name={name} />
          <Typography mb={1}>
            เลือกช่องทางการมีส่วนร่วมและสื่อสาร (เลือกได้หลายข้อ)
          </Typography>
          <SearchCheckboxList
            filterText={filterText}
            handleChange={handleFilterChange}
          />
          <FormCheckboxList
            disabled={isCompletedEn || isCompletedTh}
            name={name}
            filter={filteredStakeholders}
          />
          <InputOtherSection
            name="otherCommunicationActivities"
            title="ช่องทางการมีส่วนร่วมอื่น ๆ (ถ้ามี)"
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default CommunicationActivitiesCheckboxList;
